import type {SectionVisibilityResource} from '~/types/api-raw-types';

export enum SectionsVisibilityType {
    TASK_LIST = 'TASK_LIST',
    VISIBILITY_ALERT_BLOCK = 'VISIBILITY_ALERT_BLOCK',
    PORTFOLIO = 'PORTFOLIO',
    EXTERNAL_REPUTATION = 'EXTERNAL_REPUTATION',
    SHARE_YOUR_PROFILE = 'SHARE_YOUR_PROFILE',
    SIMILAR_PROFILES = 'SIMILAR_PROFILES',
    PROPOSE_A_PROJECT = 'PROPOSE_A_PROJECT',
    ADD_TO_FAVORITES = 'ADD_TO_FAVORITES',
    FUNCTIONAL_SKILLS = 'FUNCTIONAL_SKILLS',
    INDUSTRY_EXPERTISE = 'INDUSTRY_EXPERTISE',
    WORKPLACE_PREFERENCES = 'WORKPLACE_PREFERENCES',
    ONBOARDING_STRATEGY = 'ONBOARDING_STRATEGY',
    RECOMMENDATIONS = 'RECOMMENDATIONS',
    BREADCRUMBS = 'BREADCRUMBS',
    BADGES = 'BADGES',
    TRANSLATION = 'TRANSLATION',
    ASYNC_TRANSLATION = 'ASYNC_TRANSLATION',
    SEARCH_LINKS = 'SEARCH_LINKS',
    VIEW_MORE_LOCK = 'VIEW_MORE_LOCK',
    DESCRIPTION = 'DESCRIPTION',
    EXPERIENCES = 'EXPERIENCES',
    EDUCATIONS = 'EDUCATIONS',
    CERTIFICATIONS = 'CERTIFICATIONS',
    APPRAISALS = 'APPRAISALS',
    LANGUAGES = 'LANGUAGES',
    PROFILE_RELATIONS = 'PROFILE_RELATIONS',
    PROFILE_PRODUCT_TOUR = 'PROFILE_PRODUCT_TOUR',
    SUGGESTED_FOR_YOU = 'SUGGESTED_FOR_YOU',
}
export const sectionsVisibilityTypesFromBackend = {
    [SectionsVisibilityType.VISIBILITY_ALERT_BLOCK]: SectionsVisibilityType.VISIBILITY_ALERT_BLOCK,
    [SectionsVisibilityType.PORTFOLIO]: SectionsVisibilityType.PORTFOLIO,
    [SectionsVisibilityType.EXTERNAL_REPUTATION]: SectionsVisibilityType.EXTERNAL_REPUTATION,
    [SectionsVisibilityType.SHARE_YOUR_PROFILE]: SectionsVisibilityType.SHARE_YOUR_PROFILE,
    [SectionsVisibilityType.SIMILAR_PROFILES]: SectionsVisibilityType.SIMILAR_PROFILES,
    [SectionsVisibilityType.PROPOSE_A_PROJECT]: SectionsVisibilityType.PROPOSE_A_PROJECT,
    [SectionsVisibilityType.ADD_TO_FAVORITES]: SectionsVisibilityType.ADD_TO_FAVORITES,
    [SectionsVisibilityType.FUNCTIONAL_SKILLS]: SectionsVisibilityType.FUNCTIONAL_SKILLS,
    [SectionsVisibilityType.INDUSTRY_EXPERTISE]: SectionsVisibilityType.INDUSTRY_EXPERTISE,
    [SectionsVisibilityType.WORKPLACE_PREFERENCES]: SectionsVisibilityType.WORKPLACE_PREFERENCES,
    [SectionsVisibilityType.ONBOARDING_STRATEGY]: SectionsVisibilityType.ONBOARDING_STRATEGY,
    [SectionsVisibilityType.RECOMMENDATIONS]: SectionsVisibilityType.RECOMMENDATIONS,
    [SectionsVisibilityType.BREADCRUMBS]: SectionsVisibilityType.BREADCRUMBS,
    [SectionsVisibilityType.BADGES]: SectionsVisibilityType.BADGES,
    [SectionsVisibilityType.TRANSLATION]: SectionsVisibilityType.TRANSLATION,
    [SectionsVisibilityType.ASYNC_TRANSLATION]: SectionsVisibilityType.ASYNC_TRANSLATION,
    [SectionsVisibilityType.SEARCH_LINKS]: SectionsVisibilityType.SEARCH_LINKS,
    [SectionsVisibilityType.VIEW_MORE_LOCK]: SectionsVisibilityType.VIEW_MORE_LOCK,
    [SectionsVisibilityType.PROFILE_PRODUCT_TOUR]: SectionsVisibilityType.PROFILE_PRODUCT_TOUR,
} as const;

export type SectionsVisibilityTypeFromBackend = keyof typeof sectionsVisibilityTypesFromBackend;

export type SectionsVisibilityResource = {
    visibleSections: SectionsVisibilityTypeFromBackend[];
};

export class SectionsVisibility {
    visibleSections: SectionsVisibilityTypeFromBackend[];

    constructor(params: SectionVisibilityResource) {
        this.visibleSections = params?.visible?.map((visibleSection) => sectionsVisibilityTypesFromBackend[visibleSection]);
    }

    toJSON() {
        return {
            ...this,
        };
    }
}
